export default {
  section_fallback: 'Seção' ,
  title: '{section} — em construção',
  body: 'Previsto no roadmap do Web completo. O essencial hoje está em Mapa, Dispositivos, Cercas e Alertas.',
}
